import React from 'react';
import { HexColorInput, HexAlphaColorPicker } from 'react-colorful';
import toggleColorPicker from '../../../Functions/toggleColorPicker';

const Colors = ({ widget, handleInputChange, setColorsAndPreview }) => {
  const { monthlypayment } = widget.htmlData;

  const colorFields = [
    { key: 'principalDot', label: 'Principal & Interest' },
    { key: 'taxDot', label: 'Property Tax' },
    { key: 'insuranceDot', label: 'Home Insurance' },
    { key: 'hoaDot', label: 'HOA Fees' },
    // { key: 'mortgageDot', label: 'Mortgage Insurance' },
  ];

  return (
    <div className="mjwi-acc-panel-wrapper">
      {colorFields.map(({ key, label }) => (
        <div key={key} className="mjwi-row">
          <div className="mjwi-col50">
            <label>{label}</label>
          </div>
          <div className="mjwi-col50 mjwi-clr-picker">
            <span
              className="clrPickerVal"
              style={{ backgroundColor: monthlypayment.colors[key] }}
              onClick={toggleColorPicker}
            ></span>
            <HexAlphaColorPicker
              color={monthlypayment.colors[key]}
              onChange={(color) => setColorsAndPreview('colors', key, color)}
              className="mjwi-apfl-color"
            />
            <HexColorInput
              color={monthlypayment.colors[key]}
              onChange={(color) => setColorsAndPreview('colors', key, color)}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Colors;